import React, { useEffect, useState } from "react";

import { Eye, BookOpen } from "icons";
import { components } from "react-select";

import ingestionDataApi from "apis/ingestionData";
import { Select, Typography, Accordion } from "clearsense-ui/components";

const DBPreview = ({
  selectedColumns,
  previewTables,
  currentTab,
  setSelectedColumns,
  setPreviewTables,
  setCurrentTab,
}) => {
  const [isDBTablesLoading, setIsDBTablesLoading] = useState(false);
  const [isDBSchemaLoading, setIsDBSchemaLoading] = useState(false);
  const [dbSchemas, setDBSchemas] = useState([]);
  const [schemaTables, setSchemaTables] = useState([]);
  const [currentSchema, setCurrentSchema] = useState("");

  const { Option } = components;
  const IconOption = props => (
    <Option {...props} className="flex items-center">
      <props.data.icon size={props.data.size} className="mr-2" />
      {props.data.label}
    </Option>
  );

  useEffect(() => {
    fetchDBSchemas();
  }, []);

  const fetchDBSchemas = async () => {
    setIsDBSchemaLoading(true);
    try {
      const res = await ingestionDataApi.fetchSchemas();
      setDBSchemas(res.data.result);
    } catch (error) {
      logger.error(error);
    } finally {
      setIsDBSchemaLoading(false);
    }
  };

  const fetchDBSchemaTables = async schema => {
    setSchemaTables([]);
    setIsDBTablesLoading(true);
    try {
      const res = await ingestionDataApi.fetchSchemaTables(schema);
      setSchemaTables(res.data.result);
    } catch (error) {
      logger.error(error);
    } finally {
      setIsDBTablesLoading(false);
    }
  };

  const fetchDBColumnDetails = async table => {
    setIsDBTablesLoading(true);
    try {
      const res = await ingestionDataApi.fetchTableColumns(table);
      setSelectedColumns(prev => ({ ...prev, [table]: res.data.result }));
    } catch (error) {
      logger.error(error);
    } finally {
      setIsDBTablesLoading(false);
    }
  };

  const fetchPreview = async table => {
    try {
      setPreviewTables(prev => ({ ...prev, [table]: "loading" }));
      const res = await ingestionDataApi.fetchPreview(currentSchema, table);
      setPreviewTables(prev => ({ ...prev, [table]: res.data.result }));
    } catch (err) {
      logger.log(err);
    }
  };

  return (
    <div
      className="border-r w-80 p-2 absolute divide-y space-y-4 overflow-y-auto"
      style={{
        height: "calc(100% - 80px)",
      }}
    >
      <div className="space-y-6">
        <Select
          label="DB Schema"
          isLoading={isDBSchemaLoading}
          options={dbSchemas?.map(schema => ({ label: schema, value: schema }))}
          onChange={option => {
            fetchDBSchemaTables(option.value);
            setCurrentSchema(option.value);
          }}
        />
        <Select
          isMulti
          label="Table/View Name"
          isLoading={isDBTablesLoading}
          components={{ Option: IconOption }}
          options={schemaTables.map(table => ({
            label: table[0],
            value: table[0],
            icon: table[1] === "BASE TABLE" ? BookOpen : Eye,
            size: table[1] === "BASE TABLE" ? 16 : 20,
          }))}
          onChange={(_, { action, option, removedValue }) => {
            if (action === "select-option") {
              fetchDBColumnDetails(option.value);
              fetchPreview(option.value);
              setCurrentTab(option.value);
            } else if (action === "remove-value") {
              const selectedColumnsCopy = { ...selectedColumns };
              delete selectedColumnsCopy[removedValue.value];
              setSelectedColumns(selectedColumnsCopy);
              const previewTablesCopy = { ...previewTables };
              delete previewTablesCopy[removedValue.value];
              setPreviewTables(previewTablesCopy);
              currentTab === removedValue.value && setCurrentTab("results");
            } else {
              setSelectedColumns([]);
              setPreviewTables({});
              setCurrentTab("results");
            }
          }}
        />
      </div>
      <Accordion className="pt-4">
        {Object.keys(selectedColumns).map((column, idx) => (
          <Accordion.Item
            key={idx}
            title={column}
            className="my-0 mb-4 text-xl text-indigo-500 truncate"
          >
            {selectedColumns?.[column]?.map((item, idx) => (
              <div key={idx} className="flex justify-between mx-2">
                <Typography className="truncate">{item[0]}</Typography>
                <Typography className="text-gray-400">{item[1]}</Typography>
              </div>
            ))}
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};

export default DBPreview;
